import { get } from "lodash";
import { SUR_COMPLEMENT_WEIGHT } from "utils/constants";

const toOfferItem = (name, cost, currency) => ({
  name: name || "",
  cost: Number(cost) || 0,
  ...(currency ? { currency } : {}),
});

export const buildRecapOfferSections = ({
  formuleName,
  formuleCost,
  upsells = [],
} = {}) => {
  const packUpsell = upsells.find(
    (upsell) => Number(get(upsell, "weight")) === SUR_COMPLEMENT_WEIGHT,
  );
  const renfortUpsells = upsells.filter(
    (upsell) => Number(get(upsell, "weight")) !== SUR_COMPLEMENT_WEIGHT,
  );

  return {
    formule: toOfferItem(formuleName, formuleCost),
    pack: packUpsell
      ? toOfferItem(
          get(packUpsell, "insurancePlan.name"),
          packUpsell.cost,
          get(packUpsell, "currency"),
        )
      : null,
    renforts: renfortUpsells
      .map((upsell) =>
        toOfferItem(
          get(upsell, "insurancePlan.name"),
          upsell.cost,
          get(upsell, "currency"),
        ),
      )
      .filter(({ name }) => name),
  };
};
